import { forgetAccountingAccess } from '@/lib/accounting-access-hint'

type BrowserSessionCleanup = () => void

const browserSessionCleanups = new Set<BrowserSessionCleanup>()

export function registerBrowserSessionCleanup(cleanup: BrowserSessionCleanup): () => void {
  browserSessionCleanups.add(cleanup)
  return () => browserSessionCleanups.delete(cleanup)
}

/**
 * Session state kept in storage by modules a document may never load before sign-out, so it is
 * cleared here by name rather than through a cleanup that module would have had to register.
 */
const STORED_SESSION_STATE: readonly BrowserSessionCleanup[] = [forgetAccountingAccess]

export function clearBrowserSessionState(): void {
  for (const cleanup of [...STORED_SESSION_STATE, ...browserSessionCleanups]) {
    try {
      cleanup()
    } catch {
      // One best-effort cleanup must not prevent the remaining session state
      // from being cleared before logout or impersonation.
    }
  }
}
